<template>
   <div>
      <div v-show="showModal" class="modal1">
         <div class="modal-content">
            <div class="custom-container-1440 feedback-model" style="padding:0px;">
               <div class="fc_feedback_header">
                  <span
                     class=""
                     style="display:flex; justify-content: space-between; align-items: center;"
                  >
                     <div style="display: flex; align-items: center;">
                        <i class="fc-icon-feedback"></i>
                        <span>Ask FusionDev AI</span>
                     </div>
                     <span class="close" @click="closeModal">&times;</span>
                  </span>
               </div>

               <div class="modal-content-inner-heading"><h2>How was your experience?</h2></div>
               <div class="modal-content-inner">
                  <p class="feedback_p">
                     Select your current satisfaction level and briefly explain your reason in the
                     textbox.
                  </p>
                  <p
                     v-if="submitted"
                     :class="{
                        success_feedback: !showErrorMessage,
                        'error-message': showErrorMessage,
                     }"
                  >
                     {{ feedbackMessage }}
                  </p>
                  <!-- Stars rating
                  <div class="stars" @click="hideErrorMessage()">
                  <span  v-for="star in 5" :key="star" :class="{ 'selected': star <= selectedRating }" @click="selectRating(star)">&#9733;</span>
                  </div>-->

                  <div class="face-images-container">
                     <div class="face-images">
                        <div
                           class="feedback-item text-center"
                           :class="{ 'selected-face': selectedRating === 1 }"
                           @click="selectFace(1)"
                        >
                           <div class="face-images">
                              <img loading="lazy" src="/public/images/chat-feedback/fc-icon-feedback-poor.svg"  alt="Feedback Icon Poor | FC" />
                           </div>
                           <div class="feedback-text">
                              Poor
                           </div>
                        </div>
                     </div>
                     <div class="face-images">
                        <div
                           class="feedback-item text-center"
                           :class="{ 'selected-face': selectedRating === 2 }"
                           @click="selectFace(2)"
                        >
                           <div class="face-images">
                              <img
                                 src="/public/images/chat-feedback/fc-icon-feedback-unhappy.svg" alt="Feedback Icon Unhappy | FC"
                              />
                           </div>
                           <div class="feedback-text">
                              Unhappy
                           </div>
                        </div>
                     </div>
                     <div class="face-images">
                        <div
                           class="feedback-item text-center"
                           :class="{ 'selected-face': selectedRating === 3 }"
                           @click="selectFace(3)"
                        >
                           <div class="face-images">
                              <img
                                 src="/public/images/chat-feedback/fc-icon-feedback-neutral.svg" alt="Feedback Icon Neutral | FC"
                              />
                           </div>
                           <div class="feedback-text">
                              Neutral
                           </div>
                        </div>
                     </div>
                     <div class="face-images">
                        <div
                           class="feedback-item text-center"
                           :class="{ 'selected-face': selectedRating === 4 }"
                           @click="selectFace(4)"
                        >
                           <div class="face-images">
                              <img loading="lazy" src="/public/images/chat-feedback/fc-icon-feedback-happy.svg" alt="Feedback Icon Happy | FC" />
                           </div>
                           <div class="feedback-text">
                              Happy
                           </div>
                        </div>
                     </div>
                     <div class="face-images">
                        <div
                           class="feedback-item text-center"
                           :class="{ 'selected-face': selectedRating === 5 }"
                           @click="selectFace(5)"
                        >
                           <div class="face-images">
                              <img
                                 src="/public/images/chat-feedback/fc-icon-feedback-amazing.svg"
                                 alt="Feedback Icon Amazing | FC"
                              />
                           </div>
                           <div class="feedback-text">
                              Amazing
                           </div>
                        </div>
                     </div>
                  </div>
                  <!-- Feedback input -->
                  <textarea
                     id="user-feedback-textarea"
                     v-model="feedbackText"
                     name="user-feedback-textarea"
                     placeholder="Please provide your feedback..."
                  ></textarea>
                  <!-- Submit button -->
                  <div style="text-align:center;margin-top:5px;">
                     <button
                        id="feedback-btn"
                        class="mt-1 btn btn-primary-grad navbar-btn navbar-btn--download"
                        @click="submitFeedback"
                     >
                        Send Feedback
                     </button>
                     <div class="close1 cancle_btn text-center" @click="closeModal">Cancel</div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'FeedbackModal',
   props: {
      showModal: Boolean,
   },
   data() {
      return {
         selectedRating: 0,
         feedbackText: '',
         submitted: false,
         showErrorMessage: false,
         selectedFace: 'null',
         feedbackMessage: 'Please wait while we process your request.',
      };
   },
   methods: {
      hideErrorMessage() {
         // This method will be called when the stars are clicked, hiding the error message
         this.submitted = false;
         this.showErrorMessage = false;
      },
      closeModal() {
         this.feedbackText = '';
         this.selectedRating = 0;
         this.submitted = false;
         document.getElementById('feedback-btn').disabled = false;
         this.$emit('close');
      },
      selectFace(rating) {
         this.selectedRating = rating;
         this.submitted = false;
         this.showErrorMessage = false;
         // console.log(`${this.selectedRating}selected`);
      },
      submitFeedback() {
         if (!this.selectedRating) {
            this.feedbackMessage = 'Before submitting, please select an option';
            this.showErrorMessage = true;
            this.submitted = true;
            return;
         }
         this.feedbackMessage = 'Please wait while we process your request.';
         let feedback;
         document.getElementById('feedback-btn').disabled = true;
         this.submitted = true;
         if (!this.feedbackText) {
            feedback = 'blank';
         } else {
            feedback = this.feedbackText;
         }
         let aidaLib;
         if (!aidaLib) {
            aidaLib = aida.AIDA_Library.initialize(
               this.$parent.$parent.clientname,
               this.$parent.$parent.clientkey,
               ""
            );
         }
         aidaLib.sendFeedback(this.selectedRating, feedback).then(
            answer => {
               // debugger;
               this.feedbackMessage = "Feedback received! We're on it.";
               this.feedbackText = '';
               this.selectedRating = 0;
               this.submitted = true;
               return answer.data.aida_feedback_id;
            },
            error => {
               // debugger;

               if (error.aida_error_id && error.aida_error_description) {
                  // console.error(` Error id: ${error.aida_error_id}, Error description: ${error.aida_error_description}`);
                  this.submitted = true;
                  this.feedbackMessage = ` Error description: ${error.aida_error_description}`;
                  document.getElementById('feedback-btn').disabled = false;
                  return false;
               }
               return false;
            }
         );
         // Here you can implement the functionality to submit feedback
         // For now, let's just emit an event to close the modal
         // this.$emit('submit', { rating: this.selectedRating, feedback: this.feedbackText });
         // this.closeModal();
      },
   },
};
</script>

<style scoped>
/* Modal styles */
.modal1 {
   display: var(--showModal);
   position: fixed;
   z-index: 1;
   left: 0;
   top: 0;
   width: 100%;
   height: 100%;
   overflow: auto;
   background-color: rgba(0, 0, 0, 0.4);
}
.feedback-model{
   margin:0px;
}
.fc_feedback_header {
   background: linear-gradient(90deg, #2cc7c0, #59d99d);
   color: white;
   padding: 15px 10px;
   border-top-left-radius: 12px;
   border-top-right-radius: 12px;
}
.fc-icon-feedback {
   background-image: url('/public/images/chat-feedback/fc-icon-feedback.svg');
   height: 26px;
   width: 32px;
   display: inline-block;
   background-repeat: no-repeat;
   margin-right: 10px;
}
.fc_feedback_header span {
   font-size: 17px;
}
.cancle_btn {
   font-size: 19px;
   padding-top: 14px;
   cursor: pointer;
}
#user-feedback-textarea {
   width: 100%;
   height: 100px;
}
.modal-content {
   background-color: #fefefe;
   border: 1px solid #888;
    width: 13%;
   margin: 15% auto;
   @media (max-width: 575.98px) {
      width: 91%;
      margin: 25% auto;
   }
   @media (min-width: 576px) and (max-width: 767.98px) {
      width: 69%;
      margin: 25% auto;
   }
   @media (min-width: 768px) and (max-width: 991.98px) {
      width: 40%;
      margin: 25% auto;
   }
  @media (min-width: 992px) and (max-width: 1191.98px) {
      width: 35%;
      margin: 25% auto;
   }
   @media (min-width: 1200px) and (max-width: 1920.98px) {
      width: 30%;
   }
   @media (min-width: 1921) and (max-width: 2565.98px) {
      width: 25%;
   }
   border-top-left-radius: 12px;
   border-top-right-radius: 12px;
}
.feedback-text {
   font-size: 10px;
}
.modal-content-inner {
   padding: 20px;
   background: white;
}
.modal-content-inner-heading {
   background: #f8f9fa;
   padding: 5px 11px;
}
.close {
   color: black;
   float: right;
   font-size: 26px !important;
   font-weight: bold;
}

.close:hover,
.close:focus {
   color: black;
   text-decoration: none;
   cursor: pointer;
}
.feedback_p {
   text-align: center;
   margin-bottom: 5px;
}
.stars {
   margin-bottom: 10px;
   text-align: center;
}

.stars span {
   font-size: 30px;
   cursor: pointer;
   padding: 3px 10px;
}

.stars span.selected {
   color: gold;
}
.success_feedback,
.error-message {
   background: #cccc;
   padding: 3px;
   border-radius: 6px;
   margin-top: 11px;
   text-align: center;
   margin-bottom: 4px;
}
.error-message {
   color: red;
}
/*

.face-images{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 100%; /* Ensures the container takes full width */
/*}*/
.face-images {
   display: inline-block;
   cursor: pointer;
}
.feedback-item {
   display: inline-block;
   margin: 3px;
   border-radius: 5px;
   padding: 5px;
   background: #f2f2f2;
   border: 1px solid rgba(0, 0, 0, 0.04);
   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
}

.feedback-item:hover {
   border: 2px solid #261155;
}
.face-images img {
   height: 31px;
   width: 40px;
   cursor: pointer;
}

.face-images-container {
   display: flex;
   justify-content: space-between;
   text-align: center;
   margin-bottom: 7px;
   margin-top: 10px;
   min-height: 68px;
}

.face-images {
   flex: 1;
}
.selected-face {
   background: #dfe6ee;
   border: 1px solid #261155;
   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
}
</style>
